<section class="mt-5">
  <h2 class="h4">Annual User Certification</h2>
  <p class="text-danger">*If you are denying user certification please provide a reason in the comment field.</p>
  <p-table [columns]="cols" [value]="usersToCertify" [(selection)]="selectedUsers" [rows]="rows" [paginator]="true" [alwaysShowPaginator]="false" [autoLayout]="true" [loading]="loading"  dataKey="UserId" responsiveLayout="scroll" >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th scope="col" style="width: 3em; font-size: 1rem;">
          <p-tableHeaderCheckbox inputId="SelectAllUsers"></p-tableHeaderCheckbox>
          <span class="visually-hidden">Select All Users</span>
        </th>
        <th *ngFor="let col of columns" scope="col">
          {{col.header}}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
      <tr [pSelectableRow]="rowData">
        <td class="text-center">          
          <p-tableCheckbox [value]="rowData" [id]="'Select'+i" [attr.data-row-index]="i" (click)="clearErrorList()"></p-tableCheckbox>
        </td>
        <td [ngSwitch]="col.field" *ngFor="let col of columns">
          <ng-container *ngSwitchCase="'CertificationComment'">
            <input type="text" class="form-control" [(ngModel)]="rowData.CertificationComment" aria-label="Comment" />
          </ng-container>
          <ng-container *ngSwitchDefault>{{rowData[col.field]}}</ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <th scope="row" [attr.colspan]="columns.length + 1">
          No users require certification.
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      <p-messages [(value)]="findDenyCertificationMessages" icon="pi pi-exclamation-triangle"></p-messages>
      <div class="text-start">
        <button type="button" class="btn btn-active" (click)="certifyUsers()" [disabled]="!selectedUsers.length">Certify</button>
        <button type="button" class="btn btn-active" (click)="denyCertifyUsers()" [disabled]="!selectedUsers.length">Deny</button>
      </div>
    </ng-template>
  </p-table>
</section>
